import { render, staticRenderFns } from "./AreaFiftyOne.vue?vue&type=template&id=a1bed2c6&"
import script from "./AreaFiftyOne.vue?vue&type=script&lang=js&"
export * from "./AreaFiftyOne.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports